<template>
    <be-form-group v-bind="widgetProps">
        <textarea
            ref="el"
            class="form-control"
            :id="name"
            :name="name"
            :rows="rows"
            :placeholder="placeholder"
            :autofocus="autofocus"
            :required="required"
            :minlength="minlength || validationProp('minLength', 'min')"
            :maxlength="maxlength || validationProp('maxLength', 'max')"
            :disabled="disabled"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
        ></textarea>
    </be-form-group>
</template>

<script>
    import widget from '../../mixins/widget';

    export default {
        mixins: [widget],

        props: {
            placeholder: String,
            minlength: Number,
            maxlength: Number,
            rows: {
                type: Number,
                default: 2,
            },
        },
    };
</script>
